export default __webpack_public_path__ + "/dist/images/image12.34fc38cd4f329ad5a2765de90fb76dc2.jpg";